import api from './api';

// Customer master data (md_customer_groups + md_customers). Mirrors the volume
// service shape: grid read, bulk upsert (mode overwrite|replace), batch delete.
export const customerService = {
  // ---- Customer groups ----
  getGroups: async () => {
    const response = await api.get('/customers/groups');
    return response.data;
  },
  upsertGroups: async (payload) => {
    // payload: { mode: 'overwrite'|'replace', rows: [...] }
    const response = await api.post('/customers/groups', payload);
    return response.data;
  },
  deleteGroups: async (codes) => {
    const response = await api.delete('/customers/groups', { data: { codes } });
    return response.data;
  },

  // ---- Customers ----
  // Paging is OPT-IN: omit `limit` and the server returns everything, as before.
  // With it, the response carries total / hasMore for the grid pager.
  getCustomers: async ({ filters, limit, offset } = {}) => {
    const response = await api.get('/customers', {
      params: {
        ...(filters && Object.keys(filters).length ? { filters: JSON.stringify(filters) } : {}),
        ...(limit ? { limit } : {}),
        ...(offset ? { offset } : {}),
      },
    });
    return response.data;
  },
  upsertCustomers: async (payload) => {
    const response = await api.post('/customers', payload);
    return response.data;
  },
  deleteCustomers: async (codes) => {
    const response = await api.delete('/customers', { data: { codes } });
    return response.data;
  },
};

export default customerService;
